const VERSION = 4;

const openIndexedDB = async (): Promise<IDBDatabase> => {
    const dbResquest = window.indexedDB.open('CONSULTA', VERSION);
    let db: IDBDatabase;

    return new Promise<IDBDatabase>((resolve, reject) => {
        dbResquest.onerror = event => {
            const { target } = event;
            console.error('Error on open IndexedDB: ', (target as any).error);
            reject((target as any).error);
        };

        dbResquest.onupgradeneeded = event => {
            db = (event.target as IDBOpenDBRequest).result;

            if (!db.objectStoreNames.contains('consulta')) {
                const objectStore = db.createObjectStore('consulta', {
                    autoIncrement: true,
                });
                objectStore.createIndex('search_id', 'search_id');
                objectStore.createIndex('cod_acervo', 'cod_acervo', {
                    unique: false,
                });
            }

            if (!db.objectStoreNames.contains('expiracao')) {
                const objectStore = db.createObjectStore('expiracao', {
                    keyPath: 'search_text',
                });
                objectStore.createIndex('search_id', 'search_id');
            }
        };

        dbResquest.onsuccess = event => {
            db = (event.target as IDBOpenDBRequest).result;
            resolve(db);
        };
    });
};

const clearTables = async (tables: string[]) => {
    const db = await openIndexedDB();
    const transaction = db.transaction(tables, 'readwrite');
    tables.forEach(x => {
        const table = transaction.objectStore(x);
        table.clear();
    });
};

const insertData = async (storeName: string, data: any): Promise<boolean> => {
    const db = await openIndexedDB();
    const transaction = db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);

    if (objectStore) {
        if (data?.length) {
            data.forEach((x: any) => objectStore.add(x));
        } else {
            objectStore.add(data);
        }
    }

    return new Promise((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(true);
        };
        transaction.onerror = e => {
            reject(e);
        };
    });
};

const getBy = async <T>(
    storeName: string,
    value: string,
    index_name?: string,
): Promise<T> => {
    const db = await openIndexedDB();
    const transaction = db.transaction([storeName], 'readonly');
    const objectStore = transaction.objectStore(storeName);

    let request: any;

    if (index_name) {
        const indexObject = objectStore.index(index_name);
        request = indexObject.get(value);
    } else {
        request = objectStore.get(value);
    }

    return new Promise<T>((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(request.result);
        };
        transaction.onerror = e => {
            reject(request.error);
        };
    });
};

const deleteAllByIndex = async (
    storeName: string,
    value: string,
    index_name?: string,
): Promise<boolean> => {
    const db = await openIndexedDB();
    const transaction = db.transaction([storeName], 'readwrite');
    const objectStore = transaction.objectStore(storeName);

    let request: any;

    if (index_name) {
        const indexObject = objectStore.index(index_name);
        request = indexObject.getAllKeys(value);
    } else {
        request = objectStore.getAllKeys(value);
    }

    request.onsuccess = (event: any) => {
        const keys = event.target.result;

        // Excluir todas as chaves encontradas
        keys.forEach(function (key: any) {
            objectStore.delete(key);
        });
    };

    return new Promise<boolean>((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(true);
        };
        transaction.onerror = e => {
            reject(request.error);
        };
    });
};

const getAllBy = async <T>(
    storeName: string,
    value: string,
    index_name?: string,
): Promise<T> => {
    const db = await openIndexedDB();
    const transaction = db.transaction([storeName], 'readonly');
    const objectStore = transaction.objectStore(storeName);

    let request: any;
    if (index_name) {
        const indexObject = objectStore.index(index_name);
        request = indexObject.getAll(value);
    } else {
        request = objectStore.getAll(value);
    }

    return new Promise<T>((resolve, reject) => {
        transaction.oncomplete = () => {
            resolve(request.result);
        };
        transaction.onerror = e => {
            reject(request.error);
        };
    });
};

export const indexDbConsulta = {
    getBy,
    getAllBy,
    insertData,
    deleteAllByIndex,
    clearTables,
};

export type IIndexDbConsultaResult = typeof indexDbConsulta;
